/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["jsonpFunctionUIB"];
/******/ 	window["jsonpFunctionUIB"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + ({"1":"responses/data-collection/saveErrors/saveErrors","2":"responses/data-collection/saveContent/saveContent","3":"responses/data-collection/saveUrlParams/saveUrlParams","4":"responses/data-collection/trackExitIntent/trackExitIntent","5":"responses/data-collection/trackGTMEvents/trackGTMEvents","6":"responses/data-collection/saveContentScore/saveContentScore","7":"responses/data-collection/switchTrigger/switchTrigger","8":"responses/data-feeds/readDataFeed/readDataFeed","9":"responses/surveys/dialog/dialog","10":"responses/tags/addToRemarketingList/addToRemarketingList","11":"responses/uihints/underTheFoldIndicator/underTheFoldIndicator","12":"responses/tags/addJavaScriptTags/addJavaScriptTags","13":"responses/data-collection/splitTrafficIntoGroups/splitTrafficIntoGroups","14":"responses/tags/showHideContent/showHideContent","15":"responses/navigate/navigateToURL/navigateToURL","16":"responses/notifications/notify/notify","17":"responses/notifications/onscreen/onscreen","18":"responses/notifications/browser/browser","19":"mustache","20":"console/console"}[chunkId]||chunkId) + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	// (c) UseItBetter Site Responses, ver. 1.23
	// (c) UseItBetter, ver. 1.2.2
	var uResponses = {
	    responses: {},
	    helpers: {},
	    c: "UseItBetter Response:"
	};
	window.uResponses = uResponses;
	uResponses.help = __webpack_require__(1);
	
	var responseLoaders = __webpack_require__(2); 
	var delayAndWait = __webpack_require__(46);
	var preprocessOptions = __webpack_require__(47);
	var templateRender = __webpack_require__(48);
	
	uResponses.list = {}
	for(var key in responseLoaders){
	    uResponses.list[key] = key;    
	}
	
	function assign(destination, source){
	    for(var key in source){
	        destination[key] = source[key];
	    }
	    return destination;
	}
	
	uResponses.findElements = __webpack_require__(4);
	
	uResponses.execute = function(responseId, options, callback, execOptions){
	    execOptions = execOptions?execOptions:{};
	    options = assign({}, options);
	    var optionsProcessed = preprocessOptions(options, templateRender);
	    if(optionsProcessed === false){
	        __webpack_require__.e/* nsure */(19, function(require){
	            var Mustache = __webpack_require__(49);
	            templateRender = Mustache.render
	            uResponses.execute(responseId, options, callback, execOptions);
	        })         
	        return;
	    }
	    callback = callback?callback:function(error){
	        if(error)
	            console.log(error);
	    };
	    var loader = responseLoaders[responseId];
	    if(loader){
	        loader(function(error, response){
	            if(!error){
	                delayAndWait(response, options, callback, execOptions)
	            }
	        });        
	    }
	    else{
	        callback(new Error("Response " + responseId + " does not exist"))        
	    }
	}
	
	function getScriptUrl(){
	    var sourceElement = document.querySelector('script[src*="uResponses."]');
	    source = sourceElement?sourceElement.getAttribute('src') :"./";
	    var name = source.split('/').pop(); 
	    return source.replace(name,"");    
	}
	
	__webpack_require__.p = getScriptUrl();
	
	function loadConsole(){
	    __webpack_require__.e/* nsure */(20, function(require){
	        var console = __webpack_require__(50);
	        console.load();
	        console.show();
	        var pendingEvents = uResponses.pendingEvents; 
	        if(!pendingEvents){
	            pendingEvents = [];
	        }
	
	        //TODO - Hacky way to force first section event to exist
	        var sectionEvents = pendingEvents.filter(function(event){
	            return event.type == "m" && event.key == "Section";
	        });
	        if(!sectionEvents || sectionEvents.length == 0){
	            var lastSection = sessionStorage.getItem("uDash.lastSection");
	            if(lastSection){
	                console.model.eventsModel.addSeparator("Section", lastSection)
	            }
	        }
	
	        for(var i = 0;i < pendingEvents.length;i++){
	            var pendingEvent = pendingEvents[i];
	            console.addEvent(pendingEvent.type, pendingEvent.key, pendingEvent.value, pendingEvent.params);                   
	        };
	
	
	        delete uResponses.pendingEvents;
	        uResponses.console = console;
	    });
	};
	
	
	uResponses.helpers.traceEvent = function(type, key, value, params){
	    if(type == 'm' || type == 'e' || type == 'a'){
	        key = key.toString();
	        var console = uResponses.console;
	        if(console){
	            console.addEvent(type, key, value, params);                   
	        }
	        else{
	            var pendingEvents = uResponses.pendingEvents;
	            if(!pendingEvents){
	               pendingEvents = [];
	               uResponses.pendingEvents = pendingEvents;
	               loadConsole(); 
	            }
	            pendingEvents.push({
	                type: type, 
	                key: key,
	                value: value,
	                params: params
	            });
	        }
	    }
	};
	
	window.addEventListener("beforeunload", function unload(event){
	    window.removeEventListener("beforeunload", unload, false);
	    var console = uResponses.console;
	    if(console)
	        console.save();
	},false);
	
	
	
	
	


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
	    var helpDictionary = null;
	    function help(response) {
	        if(helpDictionary == null){
	            var path = __webpack_require__.p + "\\uResponses.json";
	            var request = new XMLHttpRequest();
	            request.open('GET', path, false);  
	            request.send(null);
	            if (request.status === 200) {
	                helpDictionary = {}
	                var data = JSON.parse(request.responseText);
	                data.responses.forEach(function (response) {
	                    helpDictionary[response.name] = response;
	                });
	            }
	        }
	        return helpDictionary?helpDictionary[response]:null;
	    }
	    return help;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	"codeEval": function(callback){
	                var response = __webpack_require__(3);
	                callback(null, response);                
	            },
	"changePageContent": function(callback){
	                var response = __webpack_require__(8);
	                callback(null, response);                
	            },
	"saveErrors": function(callback){
	                __webpack_require__.e/* nsure */(1, function(require){
	                    var response = __webpack_require__(11);
	                    callback(null, response);
	                })                
	            },
	"saveContent": function(callback){
	                __webpack_require__.e/* nsure */(2, function(require){
	                    var response = __webpack_require__(12);
	                    callback(null, response);
	                })                
	            },
	"saveUrlParams": function(callback){
	                __webpack_require__.e/* nsure */(3, function(require){
	                    var response = __webpack_require__(13);
	                    callback(null, response);
	                })                
	            },
	"trackExitIntent": function(callback){
	                __webpack_require__.e/* nsure */(4, function(require){
	                    var response = __webpack_require__(14);
	                    callback(null, response);
	                })                
	            },
	"trackGTMEvents": function(callback){
	                __webpack_require__.e/* nsure */(5, function(require){
	                    var response = __webpack_require__(15);
	                    callback(null, response);
	                })                
	            },
	"saveContentScore": function(callback){
	                __webpack_require__.e/* nsure */(6, function(require){
	                    var response = __webpack_require__(16);
	                    callback(null, response);
	                })                
	            },
	"switchTrigger": function(callback){
	                __webpack_require__.e/* nsure */(7, function(require){
	                    var response = __webpack_require__(17);
	                    callback(null, response);
	                })                
	            },
	"readStats": function(callback){
	                __webpack_require__.e/* nsure */(8, function(require){
	                    var response = __webpack_require__(18);
	                    callback(null, response);
	                })                
	            },
	"readPivot": function(callback){
	                __webpack_require__.e/* nsure */(8, function(require){
	                    var response = __webpack_require__(19);
	                    callback(null, response);
	                })                
	            },
	"showMessage": function(callback){
	                __webpack_require__.e/* nsure */(9, function(require){
	                    var response = __webpack_require__(20);
	                    callback(null, response);
	                })                
	            },
	"showChoiceMessage": function(callback){
	                __webpack_require__.e/* nsure */(9, function(require){
	                    var response = __webpack_require__(24);
	                    callback(null, response);
	                })                
	            },
	"showQuestion": function(callback){
	                __webpack_require__.e/* nsure */(9, function(require){
	                    var response = __webpack_require__(25);
	                    callback(null, response);
	                })                
	            },
	"showClosedQuestion": function(callback){
	                __webpack_require__.e/* nsure */(9, function(require){
	                    var response = __webpack_require__(26);
	                    callback(null, response);
	                })                
	            },
	"askForEmail": function(callback){
	                __webpack_require__.e/* nsure */(9, function(require){
	                    var response = __webpack_require__(27);
	                    callback(null, response);
	                })                
	            },
	"contactForm": function(callback){
	                __webpack_require__.e/* nsure */(9, function(require){
	                    var response = __webpack_require__(29);
	                    callback(null, response);
	                })                
	            },
	"showLikertSurvey": function(callback){
	                __webpack_require__.e/* nsure */(9, function(require){
	                    var response = __webpack_require__(31);
	                    callback(null, response);
	                })                
	            },
	"showMatrixQuestion": function(callback){
	                __webpack_require__.e/* nsure */(9, function(require){
	                    var response = __webpack_require__(32);
	                    callback(null, response);
	                })                
	            },
	"addToRemarketingList": function(callback){
	                __webpack_require__.e/* nsure */(10, function(require){
	                    var response = __webpack_require__(33);
	                    callback(null, response);
	                })                
	            },
	"underTheFoldIndicator": function(callback){
	                __webpack_require__.e/* nsure */(11, function(require){
	                    var response = __webpack_require__(34);
	                    callback(null, response);
	                })                
	            },
	"addJavaScriptTags": function(callback){
	                __webpack_require__.e/* nsure */(12, function(require){
	                    var response = __webpack_require__(35);
	                    callback(null, response);
	                })                
	            },
	"splitTrafficIntoGroups": function(callback){
	                __webpack_require__.e/* nsure */(13, function(require){
	                    var response = __webpack_require__(36);
	                    callback(null, response);
	                })                
	            },
	"showHideContent": function(callback){
	                __webpack_require__.e/* nsure */(14, function(require){
	                    var response = __webpack_require__(37);
	                    callback(null, response);
	                })                
	            },
	"navigateToURL": function(callback){
	                __webpack_require__.e/* nsure */(15, function(require){
	                    var response = __webpack_require__(38);
	                    callback(null, response);
	                })                
	            },
	"notify": function(callback){
	                __webpack_require__.e/* nsure */(16, function(require){
	                    var response = __webpack_require__(39);
	                    callback(null, response);
	                })                
	            },
	"onscreenNotification": function(callback){
	                __webpack_require__.e/* nsure */(17, function(require){
	                    var response = __webpack_require__(41);
	                    callback(null, response);
	                })                
	            },
	"statusBar": function(callback){
	                __webpack_require__.e/* nsure */(17, function(require){
	                    var response = __webpack_require__(42);
	                    callback(null, response);
	                })                
	            },
	"deadlineTimer": function(callback){
	                __webpack_require__.e/* nsure */(17, function(require){
	                    var response = __webpack_require__(43);
	                    callback(null, response);
	                })                
	            },
	"changeTitle": function(callback){
	                __webpack_require__.e/* nsure */(18, function(require){
	                    var response = __webpack_require__(44);
	                    callback(null, response);
	                })                
	            },
	"showVisual": function(callback){
	                __webpack_require__.e/* nsure */(17, function(require){
	                    var response = __webpack_require__(45);
	                    callback(null, response);
	                })                
	            }};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function(findElements) {      
	        var codeEval = function(options, callback){
	            var code = options.code;
	            if (options.triggeringEvent){ 
	                if (options.triggeringEvent.key){
	                    code = code.split('{{triggeringEvent.key}}').join(options.triggeringEvent.key);
	                }
	                if (options.triggeringEvent.value){
	                    code = code.split('{{triggeringEvent.value}}').join(options.triggeringEvent.value);
	                }
	            }
	            try{
	                eval(code);
	                callback(null);
	            }   
	            catch(e){
	                callback(e);
	            } 
	        };
			return codeEval;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(5)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(ElementsFinderByPath) {
	    var finder = new ElementsFinderByPath();
	    var findByPath = finder.search.bind(finder);
	    
	    var findByCssSelector = function(selectors,findOne){
	        if (findOne){
	            return [document.querySelector(selectors)];
	        }
	        
	        var elementList = document.querySelectorAll(selectors);
	        var result = [];
	        for(var i = 0; i < elementList.length; i++){
	            result.push(elementList.item(i));
	        }
	        return result
	    
	    }
	    
	    var findElement = function(pathOrSelector){
	        return findElements(pathOrSelector,true);
	    }
	    var findElements = function(pathOrSelector,findOne){
	        var result,
	            isCssSelector = pathOrSelector.indexOf("*") == -1 && pathOrSelector.indexOf("/") == -1;
	        if(isCssSelector){
	            try{
	                result = findByCssSelector(pathOrSelector,findOne);
	            }
	            catch(e){
	                isCssSelector = false;
	            }                  
	        };
	        if(!isCssSelector){
	            try{
	                result = findByPath(pathOrSelector,findOne);
	            }
	            catch(e){
	                
	            }
	        }
	
	        return result;
	    };
	    return findElements;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Parser, ElementsPathUtils) {
			var hasWildcard = function(value){
				return value.indexOf("*") != -1;
			};
	
			var filterClassList = function(classList, prefixes){
				if(prefixes){
					classList = classList.filter(function(className){
						for(var i = 0;i < prefixes.length;i++){
							if(className.indexOf(prefixes[i]) == 0){
								return false;
							}
						} 
						return true;
					})
				}	
				return classList	
			}
	
			var makePartialSelector = function(classNameMask){
				var result = "",
					parts = classNameMask.split("*");
				//Can only support startWith partials?	
				if(parts[0].length > 2){
					result = '[class^="' + parts[0] + '"]';
				}	
				return result;
			}
	
			var GENERIC_QUERIES = {
				"div": true,
				"span": true,
				"*": true
			}
	
			var CLASS_SEPARATOR_REGEX = /[ \t\n\r]+/;
			
			var ElementsFinder = function(){
				this.parser = new Parser();
				this.ignoredElement = "uConsole";
	
				if(window.uDash){
					var uDashSettings = window.uDash._globalSettings;
					if(uDashSettings){
						this.prefixes = uDashSettings.uIgnoreClassNamesWithPrefix;
					}
				}
	
				this.constructSelector = function(path){
	                
					var selectors = [],
						immediateParent = false;
					//try to construct selector which is closest possible to the path
					for(var i = 0; i < path.length;i++){
						var pathPart = path[i],
							elementId = pathPart.elementId,
							tagName = pathPart.tagName,
							childIndex = pathPart.childIndex,
							classList = pathPart.classList,				
							currentSelector = "",
							pathPartString = pathPart.pathPartString;
						if(elementId != "") {
	                        if (hasWildcard(elementId) === false){
	                            //full id available
	                            currentSelector = tagName+"#" + elementId;
	                        }else if (elementId.indexOf('*')===0){
	                            currentSelector = tagName+'[id*="' + elementId.split('*')[1]+'"]';
	                        }else{
	                            currentSelector = tagName+'[id^="' + elementId.split('*')[0]+'"]';
	                        }
						}
						{
							if(currentSelector=='' && tagName != "" && hasWildcard(tagName) === false){
								currentSelector = currentSelector + tagName;
								/*if(childIndex == -1){
									//HACK
									currentSelector = currentSelector + "nonExistingSelector";
								}*/
							};
							if(childIndex > 0){
								currentSelector = currentSelector +  ":nth-child(" + childIndex +  ")";
							};
	                        if (classList.length>0){
	                            var classWithWildcard = false;
	                            for(var j = 0; j < classList.length;j++){
	                                var className = classList[j];
	                                if (hasWildcard(className)){
	                                    classWithWildcard = true;
	                                    break;
	                                }
	                            };
	                            if (!classWithWildcard){
	                                currentSelector = currentSelector + '.'+classList.join('.');
	                            }else{
	                                currentSelector = currentSelector + makePartialSelector(classList.join(' '));
	                            }
	                        }
						};
						var immediateChild = pathPartString.charAt(0) != "*";
						if(currentSelector != ""){
							if(immediateParent && immediateChild)
								selectors.push(">");
							selectors.push(currentSelector);
							immediateParent = pathPartString.charAt(pathPartString.length - 1) != "*";						
						}
						else{
							immediateParent = false;
						}
					};
					var selectorsString = selectors.join(" ");
					if(immediateParent === false && selectorsString != ""){
						//Select element and all its children
						selectorsString = selectorsString + "," + selectorsString + " *";
					};
					return selectorsString;				
				},
				this.getElementShortPath = function(element){
					var path = [];
					//Do not include child indexes in the path
					//Those are matched in the query selector builder
					while(element){
						var tagName = element.tagName,
							className = element.className,
							elementId = element.id,
							pathPart = tagName + "[*]";
						if(className){
							if(typeof className !== "string"){
								if("baseVal" in className){
									//Check for SVGAnimatedString
									className = className.baseVal;
								}		
								else{
									className = null;
								}						
							}
							else{
								className = className.trim();							
							}
						}		
						if(elementId){
							pathPart = pathPart +  "#" + elementId;
						}
						if(className){
							var classList = className.split(CLASS_SEPARATOR_REGEX);
							classList = filterClassList(classList, this.prefixes);
							if(classList.length){
								pathPart = pathPart + "." +  classList.join('.');
							}
						}
						path.push(pathPart);
						if(element.tagName == "HTML"){
							element = null
						}
						else{
							element = element.parentNode;
						}
					}
					return path.reverse().join("/");
				},
				this.search = function(pathString,findOne){
	                pathString = pathString.replace(/ /g, "");
					var elementsPath = this.parser.parse(pathString),
						selectors = this.constructSelector(elementsPath),
						elements = [],
						list;
					if(elementsPath.length == 0)
						return elements;
					if(selectors == ""){
						//Worst possible case - all elements are wild cards
						throw new Error("Your query is too generic");
						//list = document.querySelectorAll("body *");
					}
					else{
						if(selectors in  GENERIC_QUERIES){
							throw new Error("Your query is too generic");
						}
						if(selectors.indexOf("body") !== 0){
							selectors = "body " + selectors;	
						}
						list = document.querySelectorAll(selectors);
	                    
					}
					//Child indexes
					pathString = pathString.replace(/\[([^\]]+)]/g, "[*]");
					var pathRegex = new ElementsPathUtils().getPathRegex(pathString);
					
					//HACK - to exclude children of uConsole
					var uConsole = document.getElementById(this.ignoredElement);
					//Filter out elements not matching to wildcards
					var ignoredElements = {"SCRIPT": true, "BR": true};
					for(var i = 0; i < list.length;i++){
						var element = list.item(i);
						if(uConsole && uConsole.contains(element))
							continue;
						if(element.tagName in ignoredElements)
							continue;
						var elementPath = this.getElementShortPath(element);
						if(pathRegex.test(elementPath)){
							elements.push(element);	
	                        if (findOne) break;
						}
					}
					return elements;
				}
			};
			return ElementsFinder;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			var ParseMode = {
				TAG_NAME: 0,
				CHILD_INDEX: 1,
				AFTER_CHILD_INDEX: 2,
				ELEMENT_ID: 3,
				CLASS_LIST: 4
			};
			var PathPartParser = function(){
				this.onUnexpectedSymbol = function(){
					throw new Error("Not expected " + this.char + " at " + this.index + " position in " + this.pathPartString);
				};
				this.parseTagName = function(){
					switch(this.char){
						case "[":
							//Do not allow expression to start with index without tagName
							if(this.tagName == ""){
								throw new Error("Tagname should be preceding child index in " + this.pathPartString);
							}
							this.mode = ParseMode.CHILD_INDEX;
						break;
						case "#":
							this.mode = ParseMode.ELEMENT_ID;
						break;
						case ".": 
							this.mode = ParseMode.CLASS_LIST;
						break;
						case "]":
							this.onUnexpectedSymbol();
						break;
						case "/":
							
						break;
						default:
							this.tagName += this.char;
						break;	
					}				
				},
				this.parseChildIndex = function(){
					switch(this.char){
						case "]": 
							if(this.childIndexString == ""){
								throw new Error("Child index should not be empty in " + this.pathPartString);
							}
							//No support for multiple wildcards in the child index expression
							if(this.childIndexString == "*"){
								this.childIndex = 0;
							}
							else{
								this.childIndex = Number(this.childIndexString);
								if(isNaN(this.childIndex) || this.childIndex % 1 !== 0){
									throw new Error("Child index should be integer or * in " + this.pathPartString);
								}
							}
							this.mode = ParseMode.AFTER_CHILD_INDEX;
						break;
						case "/":
							throw new Error("No closing ] found in " + this.pathPartString);
						case ".":
						case "#":
						case "[":
							this.onUnexpectedSymbol();
						break;
						default:
							this.childIndexString += this.char;
						break;	
					}			
				},
				this.parseAfterChildIndex = function(){
					switch(this.char){
						case ".":
							this.mode = ParseMode.CLASS_LIST;
						break;
						case "*":
							this.classString = "*";
							this.mode = ParseMode.CLASS_LIST;
						break;
						case "#":
							this.mode = ParseMode.ELEMENT_ID;
						break;
						case "/":
						break;
						default:
							this.onUnexpectedSymbol();
						break;
					}	
				},
				this.parseElementId = function(){
					switch(this.char){
						case "/":
						case ".": 
							//If # is present element id can not be empty
							if(this.elementId == ""){
								throw new Error("Element id should not be empty in " + this.pathPartString);
							}
							this.mode = ParseMode.CLASS_LIST;
						break;
						case "#":
						case "[":
						case "]":
							this.onUnexpectedSymbol();
						break;
						default:
							this.elementId += this.char;
						break;	
					}			
				},
				this.parseClassList = function(){
					switch(this.char){
						case "/":
						case ".": 
							if(this.classString != ""){
								this.classList.push(this.classString);
								this.classString = "";
							}
						break;
						case "[":
						case "]":
						case "#":
							this.onUnexpectedSymbol();
						break;
						default:
							this.classString += this.char;
						break;	
					}	
				},
				this.parse = function(pathPartString){
					this.char = "";
					this.mode = ParseMode.TAG_NAME;
					this.tagName = "";
					this.elementId = "";
					this.classList = [];
					this.classString = "";
					this.childIndex = -1;
					this.childIndexString = "";
					this.pathPartString = "\"" + pathPartString + "\"";
					var pathPartWithTerminal = pathPartString + "/",
						charCount = pathPartWithTerminal.length;
					for(var i = 0; i < charCount;i++){
						this.char = pathPartWithTerminal.charAt(i);
						//Skip whitespace
						if(this.char == " ")
							continue;
						this.index = i;
						switch(this.mode){
							case ParseMode.TAG_NAME:
								this.parseTagName();
							break;
							case ParseMode.CHILD_INDEX:
								this.parseChildIndex();
							break;
							case ParseMode.AFTER_CHILD_INDEX:
								this.parseAfterChildIndex();
							break;
							case ParseMode.ELEMENT_ID:
								this.parseElementId();
							break;
							case ParseMode.CLASS_LIST:
								this.parseClassList();
							break;	
						};
					};
					return {
						pathPartString: pathPartString,
						tagName: this.tagName,
						elementId: this.elementId,
						classList: this.classList,
						childIndex: this.childIndex
					};
				};			
			};
			var ElementsPathParser = function(){
				this.parse = function(pathString){
					//Order always like this tag#id.class
					//Only one "#" symbol per path part
					var parts = pathString.split("/"),
						path = [],
						partParser = new PathPartParser();
					for(var i = 0; i < parts.length;i++){
						var pathPart = parts[i];
						//empty path parts are ignored
						if(pathPart.length != 0){
							path.push(partParser.parse(pathPart));
						}
					}
					return path;
				};
			};
			return ElementsPathParser;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	
	


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			var ElementsPathUtils = function(){
				this.getPathRegex = function(pathString, groups){
	                if (!pathString) return;
					var mask = pathString,
						wildcard = (groups === true)?"(.*)":".*";
					mask = mask.replace(/[.+?^${}()|[\]\\]/g, "\\$&");
					mask = mask.replace(/\*/g, wildcard); 
					//mask = ".*" + mask + ".*";
					//Allow only any beginning but fixed ending
					if(mask.indexOf(".*") != 0){
						mask = ".*" + mask;
					}
					return new RegExp(mask + "$", "i");
				};
			};
			return ElementsPathUtils;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(9), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function(findElements, injectJavascript, injectCSS) {    
	               
	        var addContent = function(target, htmlContent, location){
	            var div = document.createElement('div');
	            div.innerHTML = htmlContent;
	            var elements = Array.prototype.slice.call(div.childNodes);
	            switch(location){
	                case "before":
	                    elements.forEach(function(element){
	                        target.parentNode.insertBefore(element, target);
	                    });                    
	                break;
	                case "after":
	                    elements.forEach(function(element){
	                        target.parentNode.insertBefore(element, target.nextSibling);
	                    });                     
	                break;
	                case "replace":
	                    elements.forEach(function(element){
	                        target.parentNode.insertBefore(element, target);
	                    }); 
	                    target.parentNode.removeChild(target);                    
	                break;
	                case "set-content":
	                    target.innerHTML = '';
	                    elements.forEach(function(element){
	                        target.appendChild(element);
	                    });
	                break;
	                case "append":
	                    elements.forEach(function(element){
	                        target.appendChild(element);
	                    });
	                break;  
	                case "prepend":
	                    elements.forEach(function(element){
	                        target.insertBefore(element, target.childNodes[0]);
	                    });
	                break;              
	                default:
	                    throw new Error("Not supported location type")
	            }
	        }
	          
	        var changePageContent = function(options, callback){
	            var htmlContent = options.content,
	                location = options.location || "append",
	                selectors = options.selectors,
	                css = options.css,
	                javascript = options.javascript;
	            if(htmlContent){                
	                if(!selectors || selectors.length == 0){
	                    callback(new Error("selectors are required"));
	                    return;
	                }
	                var elements = [];
	                for(var i = 0;i < selectors.length;i++){
	                    var searchResults = findElements(selectors[i]);
	                    elements = elements.concat(searchResults);
	                }
	                if(elements.length == 0){
	                    callback(new Error("No elements corresponding to selectors found"));
	                    return;
	                }
	                elements.forEach(function(element){
	                    addContent(element, htmlContent, location)
	                });
	            }
	            if(javascript){
	                injectJavascript(javascript);
	            }
	            if(css){
	                injectCSS(css);
	            }
	            callback(null);
	        };
			return changePageContent;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			var injectJavascript = function(source){
	            var script = document.createElement("script");
	            script.type = "text/javascript";
	            script.appendChild(document.createTextNode(source));
	            document.head.appendChild( script );
	        }
			return injectJavascript;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			var injectCSS = function(source){
	            var style = document.createElement("style");
	            style.type = "text/css";
	            style.appendChild(document.createTextNode(source));
	            document.head.appendChild( style );
	        }
			return injectCSS;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	  
	    var checkDependencies = function(dependencies) {
	        var dependenciesAvailable = dependencies.reduce(function(value, item){
	            return (typeof window[item] !== 'undefined') && value;    
	        }, true);  
	        return dependenciesAvailable       
	    }             
	    
	                          
	    var wait = function(response, options, callback, execOptions){ 
	        var interval = execOptions.interval,
	            timeout = execOptions.timeout,  
	            startTime = new Date().getTime();  
	        var tryResponse = function(onTry){
	            try{
	                response(options, onTry)
	            }   
	            catch(e){
	                onTry(e)
	            }            
	        }       
	        var responseCallback = function(error, result){
	            if(error){
	                if(interval > 0 && timeout > 0){
	                    var delta = new Date().getTime() - startTime;
	                    if(delta < timeout){
	                        //execute again later
	                        setTimeout(tryResponse, interval, responseCallback);
	                    }
	                    else{
	                        callback(new Error("Response Timeout"));
	                    }
	                }
	                else{
	                    callback(error);
	                }
	            }
	            else{
	                callback(null, result)
	            }
	        }
	        tryResponse(responseCallback);
	    };
	    
	    var delayAndWait = function(response, options, callback, execOptions){
	        var delay = execOptions.delay, 
	            dependencies = execOptions.dependencies,
	            action = response
	        if(dependencies && dependencies.length > 0){
	            action = function(options, callback) {
	                var dependenciesAvailable = checkDependencies(dependencies);
	                if(dependenciesAvailable){
	                    response(options, callback)
	                }
	                else{
	                    callback(new Error("Dependencies not available"))
	                }
	            }
	        }
	        if(delay && delay > 0){
	            setTimeout(function(){
	                wait(action, options, callback, execOptions);
	            }, delay);    
	        }
	        else{
	            wait(action, options, callback, execOptions);
	        }
	    };
	    
	    return delayAndWait;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function(findElements) {
	
	        function findFirstElement(selector){
	            var elements = findElements(selector);
	            return (elements && elements.length)?elements[0]:null;
	        }
	
	        function findPropertyValue(property, lookUp) {
	            return function(text, render) {
	                var element = findFirstElement(render(text)),
	                    result = element?element[property]:undefined;
	                if(lookUp){
	                    while(result == undefined && element){
	                        result = element[property];
	                        element = element.parentNode;
	                    }
	                }   
	                return result;
	            }
	        }
	
	        function findAttrValue() {
	            return function(text, render) {
	                var textParts = render(text).split("|"),
	                    selector = textParts[0],
	                    property = textParts[1],
	                    result = null;
	                if(selector && property){
	                    var element = findFirstElement(selector);
	                    result = element[property];
	                }    
	                return result;
	            }
	        }
	
	        function findElementsString() {
	            return function(text, render) {
	                return 'window.uResponses.findElements("' + render(text) + '")';
	            }
	        }
	
	        var elementContext = {
	            innerText: findPropertyValue.bind(undefined, "innerText"),
	            textContent: findPropertyValue.bind(undefined, "textContent"),
	            value: findPropertyValue.bind(undefined, "value"),
	            label: findPropertyValue.bind(undefined, "label"),
	            href: findPropertyValue.bind(undefined, "href", true),
	            attr: findAttrValue,
	            find: findElementsString
	        }
	
	        var preprocessString = function(value,  options, render){
	            var context = {
	                window: window,
	                event: options.triggeringEvent,
	                element: elementContext,
	                triggeringEvent: options.triggeringEvent
	            }
	            var result = render(value, context)
	            return result
	        }
	
	        var preprocessOptions = function(options, render){
	            var result = true;
	            for(var key in options){
	                var value = options[key]
	                if(typeof value === 'string'){
	                    value = preprocessString(value, options, render)
	                    if(value.indexOf("{{") != -1){
	                        result = false; 
	                    }
	                    options[key] = value
	                }/*else if(key === 'selectors'){
	                    for (var i = 0; i<options[key].length){
	                        value = options[key][i];
	                        value = preprocessString(value, options, render)
	                        if(value.indexOf("{{") != -1){
	                            result = false; 
	                        }
	                    }
	                }*/
	            }     
	            return result
	        }
	
			return preprocessOptions;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	        var valueAtPath = function(obj, path) {
	            var pathParts = path.split('.'),
	                current = obj
	            for (var i = 0; i < pathParts.length && current !== undefined; i++){
	                current = current[pathParts[i]]
	            }
	            if(current == undefined || current == null){
	                current = "";
	            }
	            return current;
	        }
	        
	        var microTemplate = function(template, context){
	            var result = template;
	            //match functions
	            /*result = template.replace(/\{\{\#(.*?)\}\}(.*?)\{\{\/(.*?)\}\}/g, function(i, match, p1, p2, offset, source){
	                if(match != p2){
	                    return i;
	                }
	                var func = valueAtPath(context, match);
	                if(func && typeof func == 'function'){
	                    return func()(p1, null);
	                }
	                return i;
	            });*/
	            //Match simple variables starting with letter
	            result = template.replace(/\{\{([a-zA-Z].*?)\}\}/g, function(i, match) {
	                return valueAtPath(context, match);
	            });
	            return result;
	        }
			return microTemplate;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	


/***/ })

/******/ });


// WEBPACK FOOTER //
// uResponses.min.js